import { gql } from '@apollo/client';
export const GET_SUGGESTION = gql `
  query GetSuggestion($input: SuggestionInput!) {
    getSuggestion(input: $input) {
      id
      translated_name
      legacy_id
      drupal_id
      type
      parent {
        id
        translation {
          name
        }
      }
      country {
        id
        translation {
          name
        }
      }
    }
  }
`;
export const GET_COUNTRIES = gql `
  query GetCountries($brand: String!, $language: String!) {
    getCountries(brandName: $brand, languageCode: $language) {
      id
      name
      parent_id
      legacy_id
      drupal_id
      __typename
      translation(languageCode: $language) {
        id
        name
        in_destination_list(brandName: $brand)
      }
      has_children
    }
  }
`;
export const GET_LOCATION = gql `
  query GetLocation($languageCode: String!, $brandName: String!, $queryId: ID) {
    getLocation(
      brandName: $brandName
      languageCode: $languageCode
      queryId: $queryId
    ) {
      ... on Location {
        id
        parent_id
        legacy_id
        drupal_id
        __typename
        translation(languageCode: $languageCode) {
          name
          in_destination_list(brandName: $brandName)
        }
        children(brandName: $brandName) {
          id
          legacy_id
          drupal_id
          __typename
          translation(languageCode: $languageCode) {
            name
            in_destination_list(brandName: $brandName)
          }
          has_children
          parent_id
        }
        touristic_terms(brandName: $brandName) {
          id
          legacy_id
          drupal_id
          __typename
          translation(languageCode: $languageCode) {
            name
            in_destination_list(brandName: $brandName)
          }
        }
      }
    }
  }
`;
export const GET_POPULAR_AREAS = gql `
  query GetPopularAreas($brandName: String!, $countryId: ID) {
    getPopularAreas(brandName: $brandName, countryId: $countryId) {
      ... on Location {
        id
        legacy_id
        drupal_id
        name
        __typename
      }
      ... on TouristicTerm {
        id
        name
        drupal_id
        legacy_id
        __typename
      }
    }
  }
`;
export const GET_LEGACY_DESTINATION_LIST = gql `
  query GetLegacyDestinationList($brandName: String!, $languageCode: String!) {
    getCountries(brandName: $brandName, languageCode: $languageCode) {
      id
      legacy_id
      translation(languageCode: $languageCode) {
        name
        in_destination_list(brandName: $brandName)
      }
      children(brandName: $brandName) {
        id
        legacy_id
        translation(languageCode: $languageCode) {
          name
          in_destination_list(brandName: $brandName)
        }
        children(brandName: $brandName) {
          id
          legacy_id
          translation(languageCode: $languageCode) {
            name
            in_destination_list(brandName: $brandName)
          }
        }
      }
    }
  }
`;
export const GET_GOOGLE_PLACES_API_TEXT_SEARCH = gql `
  query GetGooglePlacesApiTextSearch($input: GooglePlacesApiTextSearchInput!) {
    getGooglePlacesApiTextSearch(input: $input) {
      id
      name
      translated_name
      type
      country_name
      parent_name
    }
  }
`;
export const GET_GOOGLE_PLACES_API_AUTOCOMPLETE = gql `
  query GetGooglePlacesApiAutocomplete(
    $input: GooglePlacesApiAutocompleteInput!
  ) {
    getGooglePlacesApiAutocomplete(input: $input) {
      id
      translated_name
      subtitle
      type
    }
  }
`;
export const GET_GOOGLE_PLACES_API_DETAIL = gql `
  query GetGooglePlacesApiDetail($input: GooglePlacesApiDetailInput!) {
    getGooglePlacesApiDetail(input: $input) {
      coordinates_location
    }
  }
`;
//# sourceMappingURL=queries.js.map